import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, notify } from 'shared';
@Component({
  selector: 'app-recovery-form',
  templateUrl: './recovery-form.component.html',
  styleUrls: ['./recovery-form.component.scss']
})
export class RecoveryFormComponent {
  email = '';
  loadIndicatorVisible = false;

  constructor(private authService: AuthService, private router: Router) {
  }


  onRecoveryClick(args) {
    if (!args.validationGroup.validate().isValid) {
      return;
    }
    this.loadIndicatorVisible = true;

    const baseUrl = `${window.location.protocol}//${window.location.host}`;

    this.authService.recovery(this.email, baseUrl).subscribe(
      () => {
        notify('Un e-mail pour réinitialiser votre mot de passe a été envoyé à votre adresse.', 'success', 6000);
        this.loadIndicatorVisible = false;
        this.router.navigate(['/login']);
      }, () => {
        notify('Désolé, une erreur est survenue. Veuillez réessayer.', 'warning');
        this.loadIndicatorVisible = false;
      });
  }

}
